import type { TokenJSONObject } from '@ikegps/core-api';
import { IkeRestObject } from './base';

export class IkeObjectToken extends IkeRestObject<TokenJSONObject> {
	className = 'Token' as const;
	actionName = 'token';
	object?: TokenJSONObject;
}
